import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 175A9E67-3723-4D49-85EC-8D34B4BA0C14
 * name power-socket
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketIcon = createSvgIcon(<><path d="M15,15H17V11H15M7,15H9V11H7M11,13H13V9H11M8.83,7H15.2L19,10.8V17H5V10.8M8,5L3,10V19H21V10L16,5H8Z" /></>, 'PowerSocketIcon');
export default PowerSocketIcon